import { Big } from "big.js";
import { ZERO } from "../../shared/bigUtil.ts";
import { DisbursementType } from "../../shared/CaseConfiguration";

// The stage-from-budget helpers now live in shared so the server can use them
// too; re-export to keep existing client import sites working.
export {
  convert,
  getLastStageWithIncurredCosts,
  type CostsPerStage,
  type LawyerCostsAndDisbursements,
} from "../../shared/CaseModelUtility";

export const getDisbursementsTotal = (byType: {
  [type in DisbursementType]?: number;
}): Big =>
  Object.values(byType).reduce(
    (total, disbursement) => total.add(disbursement),
    ZERO
  );
